// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressDrawerContainerStyles } from "@ces/Overrides/Widgets/Header/AddressDrawerContainer";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

addressDrawerContainerStyles.drawerContainer = {
    gap: 22,
    css: css`
        width: 100%;
    `,
};

addressDrawerContainerStyles.addressesGridItem = addressDrawerContainerStyles.pickUpAddressGridItem = {
    width: 12,
};

addressDrawerContainerStyles.fulfillmentMethodGridItem = {
    width: 12,
};

addressDrawerContainerStyles.applyButtonGridItem = {
    css: css`
        width: 100%;
        margin-top: 35px;
        display: flex;
        justify-content: flex-end;
        &&&& ${GridOffset} {
            margin: 0;
            width: 100%;
            ${GridItemStyle} {
                padding: 0;
            }
        }
    `,
};
